import React from 'react';
import commonUtil from '../../../../../utils/commonUtil';
import TextInput from '../../../../../components/ZUILib/TextInput';


const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
export default class Combinado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transferenceData: this.props.transferenceData && this.props.transferenceData.transferenceOptions,
      transferableAmount: this.props.transferenceData && (+this.props.transferenceData.transferenceOptions.transferableAmount),
      walletAmount: this.props.transferenceData && (+this.props.transferenceData.transferenceOptions.transferableAmount),
      bonusAmount: this.props.transferenceData && (+this.props.transferenceData.transferenceOptions.bonusAmount),
      cardBankAmount: 0.00,
    };
  }
  onUserBankCardClearState = () => {
    this.props.disableContinueButton(true);
  }
  onAmountInputChange = (e) => {
    // const actualAmount = this.state.transferableAmount;
    const oppTextInput = e.target.name === 'cardBankAmount' ? 'walletAmount' : 'cardBankAmount';
    const adjustedValue = this.state.transferableAmount - (+e.target.value);

    if (e.target.name === 'cardBankAmount') {
      if (e.target.value <= this.state.walletAmount) {
        const bounusValueDeduction = this.state.transferenceData.bonusAmount - ((e.target.value * this.state.transferenceData.bonusPercentage) / 100);
        this.setState({
          bonusAmount: (Math.round(bounusValueDeduction * 100) / 100),
        });
      }
    } else if (e.target.name === 'walletAmount' && (e.target.value === '0' || e.target.value === '')) {
      const bounusValueDeduction = this.state.transferenceData.bonusAmount - ((this.state.transferableAmount * this.state.transferenceData.bonusPercentage) / 100);
      this.setState({
        bonusAmount: (Math.round(bounusValueDeduction * 100) / 100),
      });
    } else {
      const bounusValueDeduction = this.state.transferenceData.bonusAmount - ((this.state.cardBankAmount * this.state.transferenceData.bonusPercentage) / 100);
      this.setState({
        bonusAmount: (Math.round(bounusValueDeduction * 100) / 100),
      });
    }
    // const regEx = /^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/;
    // this.state[e.target.name] = regEx.test(e.target.value) ? +e.target.value : 0;
    if (adjustedValue > 0) {
      this.props.disableContinueButton(false);
      this.setState({
        // [e.target.name]: regEx.test(e.target.value) ? +e.target.value : 0,
        [e.target.name]: (Math.round(+e.target.value * 100) / 100),
        [oppTextInput]: (Math.round(adjustedValue * 100) / 100),
      });
    } else {
      this.props.disableContinueButton(true);
    }
  }

  getFormData = () => {
    let reqParams = {};
    reqParams = {
      cardOrBankAmount: this.state.cardBankAmount.toString(),
      walletOrEmployeeCardAmount: this.state.walletAmount.toString(),
      bonusAmount: this.state.bonusAmount.toString(),
      totalAmount: Math.round(this.state.cardBankAmount + this.state.walletAmount + this.state.bonusAmount).toString(),
      paymentMode: '4',
    };
    return reqParams;
  }

  render() {
    return (
      <div>
        {channel === constChannels.WAP ?
          <div className="contentInfo infoActive" style={{ display: 'block' }}>
            <div className="innerInfo innerComb">
              <div className="quantityBlock closureQuantityBlock">
                <label>Cantidad a cuenta bancaria o tarjeta:</label>
                <TextInput
                  beforeElement={<span className="input-group-addon">$</span>}
                  parentClassName="materialStyle input-group"
                  className="typeNumber inputMaterial"
                  placeholder=" "
                  maxlength="10"
                  name="cardBankAmount"
                  onChange={this.onAmountInputChange}
                  inputValue={this.state.cardBankAmount}
                />
                <p>Se cobrará comisión por depósito a cuenta bancaria o tarjeta</p>
              </div>
              <div className="quantityBlock closureQuantityBlock">
                <label>Cantidad a monedero</label>
                <TextInput
                  beforeElement={<span className="input-group-addon">$</span>}
                  parentClassName="materialStyle input-group"
                  className="typeNumber inputMaterial"
                  placeholder=" "
                  maxlength="10"
                  name="walletAmount"
                  onChange={this.onAmountInputChange}
                  inputValue={this.state.walletAmount}
                />
              </div>
              <i className="iClass icon-ayuda tooltip-container">
                <span className="tooltip-box">
                  Todos los regalos y compras personales participantes para bonificación.</span>
              </i><p className="fontBold">Bono total</p>
              <hr />
              <p>Total</p>
              <p><span className="estimatedQuant">{commonUtil.getCurrency(Math.round(this.state.cardBankAmount + this.state.walletAmount + this.state.bonusAmount))}</span></p>
            </div>
          </div>
          :
          <div className="row display-block" id="option2">
            <p><small>{commonUtil.getLabel(this.props.lables['Close Event - Combination of Liverpool card and bank account'], 'eventClosure.slider.message')}</small></p>
            <div className="col-md-3 col-sm-3">
              <div className="quantityBlock bankStyle">
                <p><small>
                  <label htmlFor="amount-quantity">Cantidad a cuenta bancaria o tarjeta:</label></small>
                </p>
                <TextInput
                  beforeElement={<span className="input-group-addon">$</span>}
                  parentClassName="materialStyle input-group"
                  className="typeNumber inputMaterial"
                  placeholder=" "
                  maxlength="10"
                  name="cardBankAmount"
                  onChange={this.onAmountInputChange}
                  inputValue={this.state.cardBankAmount}
                />
                <p />
                <p><small>Se cobrará comisión por depósito a cuenta bancari o tarjeta</small></p>
              </div>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="quantityBlock bankStyle">
                <p><small>
                  <label htmlFor="amount-wallet">Cantidad a monedero:</label></small>
                </p>
                <TextInput
                  beforeElement={<span className="input-group-addon">$</span>}
                  parentClassName="materialStyle input-group"
                  className="typeNumber inputMaterial"
                  placeholder=" "
                  maxlength="10"
                  name="walletAmount"
                  onChange={this.onAmountInputChange}
                  inputValue={this.state.walletAmount}
                />
                <p />
              </div>
            </div>
            <div className="wrapOperator">
              <div className="operator">+</div>
            </div>
            <div className="col-md-2 col-sm-2 pt10"><small>&nbsp;Bono total</small>
              <div className="quantityBlock bankStyle"><strong className="quantity">{commonUtil.getCurrency(this.state.bonusAmount)}</strong></div>
            </div>
            <div className="wrapOperator">
              <div className="operator">=</div>
            </div>
            <div className="col-md-2 col-sm-2 pt10"><small>&nbsp;Total</small>
              <div className="quantityBlock bankStyle"><strong className="quantity">{commonUtil.getCurrency(Math.round(this.state.cardBankAmount + this.state.walletAmount + this.state.bonusAmount))}</strong></div>
            </div>
          </div>}
      </div>
    );
  }
}
